import { RootState } from './store'

export const customTheme = (state: RootState) => state.customization
export const authStore = (state: RootState) => state.auth
export const customerStore = (state: RootState) => state.customer
export const orderStore = (state: RootState) => state.order
export const advanceStore = (state: RootState) => state.advance
export const offerToPayStore = (state: RootState) => state.offerToPay
export const reimburseStore = (state: RootState) => state.reimburse
